import { z } from 'zod';

/** Liste controllate del mondo Partner. */

export const TipoPartner = z.enum(['Azienda', 'Professionista', 'Ente', 'Altro']);
export type TipoPartner = z.infer<typeof TipoPartner>;
